import React from 'react';
import './AboutUsBanner.scss';
import icon1 from '../../img/icon1.png';
import icon2 from '../../img/icon2.png';
import icon3 from '../../img/icon3.png';
import icon4 from '../../img/icon4.png';


const AboutUs = () => {
  return (
    <section className="about-us-section">
      <div className="container text-center">
        {/* About Us Section */}
        <div className="about-us-section">
        <div className="container text-center">
          <h5 className="section-title">About Us</h5>
          <h2 className="section-headline">Decades of Dedication, <span className="highlight">Unwavering Quality.</span></h2>
          <p className="section-text">
            For over <strong>32 years</strong>, <span className="company-name">RAN GLOBAL AUTO ENGG PVT LTD</span> has been a 
            trusted partner in the automotive industry. Our legacy is built on <strong>precision engineering</strong>, 
            <strong>advanced manufacturing</strong>, and a <span className="emphasized-text">relentless pursuit of excellence.</span>  
            From our <span className="highlight">humble beginnings</span> to our <span className="highlight">state-of-the-art facilities</span>, 
            we've consistently delivered high-quality <strong>stamped auto components</strong> that meet evolving industry needs.
          </p>
        </div>
      </div>
      <img src={icon1} alt="Icon 1" className="aboutus-icon aboutus-icon-1" />
      <img src={icon2} alt="Icon 2" className="aboutus-icon aboutus-icon-2" />
      <img src={icon3} alt="Icon 3" className="aboutus-icon aboutus-icon-3" />
      <img src={icon4} alt="Icon 4" className="aboutus-icon aboutus-icon-4" />



        {/* Capabilities Section */}
        <div className="container mt-5">
  <h3 className="section-subheadline text-center mb-4">
    Comprehensive Stamping Solutions Tailored to Your Needs
  </h3>
  <div className="row">
    {[
      {
        icon: "fas fa-cogs",
        title: "Precision Stamping",
        desc: "Advanced presses and tooling for intricate and accurate components."
      },
      {
        icon: "fas fa-wrench",
        title: "Welding & Assembly",
        desc: "Complete solutions from component manufacturing to finished assemblies."
      },
      {
        icon: "fas fa-tools",
        title: "Tool & Die Design",
        desc: "In-house expertise for custom tooling and die development."
      },
      {
        icon: "fas fa-industry",
        title: "Material Expertise",
        desc: "Working with steel, aluminum, and stainless steel."
      },
      {
        icon: "fas fa-check-circle",
        title: "Quality Assurance",
        desc: "Rigorous quality control for the highest industry standards."
      },
      {
        icon: "fas fa-lightbulb",
        title: "Prototyping & Development",
        desc: "Rapid prototyping services to support product innovation."
      }
    ].map((card, idx) => (
      <div className="col-12 col-md-4 mb-4" key={idx}>
        <div className="capability-card">
          <i className={card.icon}></i>
          <h4>{card.title}</h4>
          <p>{card.desc}</p>
        </div>
      </div>
    ))}
  </div>
</div>

        {/* Industries Served Section */}
        <div className="industries-section mt-5">
          <h3 className="section-subheadline">Serving Diverse Automotive Segments</h3>
          <p className="section-text">We provide critical components for:</p>
          <div className="industry-list">
            <span className="industry-badge">Passenger Vehicles</span>
            <span className="industry-badge">Commercial Vehicles</span>
            <span className="industry-badge">Two-Wheelers</span>
            <span className="industry-badge">Electric Vehicles</span>
            <span className="industry-badge">Aftermarket Components</span>
          </div>
        </div>
      </div>
    </section>

    
  );
  
};

export default AboutUs;
